const MAX_CAPTURE_WIDTH = 640;

export function isVideoFrameReady(video: HTMLVideoElement): boolean {
  return video.videoWidth > 0 && video.videoHeight > 0;
}

/** Quadro atual do vídeo em JPEG (data URL), reduzido a 640px de largura. */
export function captureVideoFrameAsDataUrl(video: HTMLVideoElement, quality = 0.85): string {
  if (!isVideoFrameReady(video)) throw new Error('vídeo sem dimensões');
  const scale = Math.min(1, MAX_CAPTURE_WIDTH / video.videoWidth);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(video.videoWidth * scale);
  canvas.height = Math.round(video.videoHeight * scale);
  const ctx = canvas.getContext('2d');
  if (!(ctx instanceof CanvasRenderingContext2D)) throw new Error('canvas 2d indisponível');
  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/jpeg', quality);
}

export function stopMediaStream(stream: MediaStream): void {
  stream.getTracks().forEach((track) => {
    try {
      track.stop();
    } catch {
      /* já encerrada */
    }
  });
}
